import { OCCURRENCE_TYPE_LABELS } from "../constants.js";
import { CadenceOccurrenceDisplay } from "./cadence/CadenceOccurrenceDisplay.js";
import { CadenceOccurrenceForm } from "./cadence/CadenceOccurrenceForm.js";
import { CadenceOccurrenceTrack } from "./cadence/CadenceOccurrenceTrack.js";
import { ContinuousOccurrenceDisplay } from "./continuous/ContinuousOccurrenceDisplay.js";
import { ContinuousOccurrenceForm } from "./continuous/ContinuousOccurrenceForm.js";
import { ContinuousOccurrenceTrack } from "./continuous/ContinuousOccurrenceTrack.js";
import { CountOccurrenceDisplay } from "./count/CountOccurrenceDisplay.js";
import { CountOccurrenceForm } from "./count/CountOccurrenceForm.js";
import { CountOccurrenceTrack } from "./count/CountOccurrenceTrack.js";
//#region src/modules/ServicePeriods/activity-evals/occurrence/index.ts
var EMPTY_OCCURRENCE = {
	cadence: {
		bufferMinutes: 0,
		cadenceMinutes: 60,
		type: "cadence"
	},
	continuous: {
		maxGapMinutes: 15,
		type: "continuous"
	},
	count: {
		minCount: 1,
		type: "count"
	}
};
var OCCURRENCE_UI = {
	cadence: {
		Display: CadenceOccurrenceDisplay,
		Form: CadenceOccurrenceForm,
		label: OCCURRENCE_TYPE_LABELS.cadence,
		subTitle: "The window is split into repeating slots. Each slot is fulfilled by one matching activity.",
		Track: CadenceOccurrenceTrack
	},
	continuous: {
		Display: ContinuousOccurrenceDisplay,
		Form: ContinuousOccurrenceForm,
		label: OCCURRENCE_TYPE_LABELS.continuous,
		subTitle: "Matching activity must keep occurring so no gap is longer than the maximum.",
		Track: ContinuousOccurrenceTrack
	},
	count: {
		Display: CountOccurrenceDisplay,
		Form: CountOccurrenceForm,
		label: OCCURRENCE_TYPE_LABELS.count,
		subTitle: "Fulfilled once this many matching activities occur in the window.",
		Track: CountOccurrenceTrack
	}
};
//#endregion
export { EMPTY_OCCURRENCE, OCCURRENCE_UI };

//# sourceMappingURL=index.js.map